import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
const STATS = [{
  value: '50 Acres',
  label: 'Beautiful private community in Greenspring Valley'
}, {
  value: '80 Residences',
  label: 'A close-knit community where neighbors become friends'
}, {
  value: 'Founded 1991',
  label: 'More than three decades of serving independent seniors'
}, {
  value: '100% Healthcare Choice',
  label: 'Continue using the providers you trust'
}];
const TESTIMONIALS = [{
  quote: 'We recently bought an apartment at Brightwood for our mom. The process was so easy because every person there is truly with the mindset… at your service! They are helping with every detail that you can think of for our moms move. The facilities are amazing. We know that our mom will be very happy in this community with these helpful, kind people.',
  name: 'Juli Finkelstein'
}, {
  quote: 'In addition to our wonderful friendships and the efficient dining, cleaning, laundry and other services, what I enjoy most at Brightwood is sitting by our library fireplace reading, watching videos, and doing puzzles in the Winter; and walking and working in the two and one-half acre woodland garden in the Spring and Fall!',
  name: 'Emily Fuchs'
}, {
  quote: 'Brightwood’s strength is its staff. Everyone is caring and goes above and beyond to keep my parents happy and safe. It’s also a lovely campus, with a wide assortment of housing options.',
  name: 'Liz Wright'
}, {
  quote: 'Brightwood is a beautiful and friendly place to live! I couldn’t ask for a better place than this for my parents to spend the rest of their lives in. The staff are amazing! The amenities and grounds are 100%.',
  name: 'Lyn Boone'
}, {
  quote: 'Our Mom moved to Brightwood 6 months ago and it has been a wonderful and easy transition. The staff as well as the residents are friendly and helpful. This truly is a very special place to call home!',
  name: 'Esther S.'
}, {
  quote: 'This community is like a resort, the grounds are kept pristine and very well maintained. Such a great setting for a healthy stroll. Very well managed — kudos to Denise and main office personnel.',
  name: 'James Olivella'
}];
function TestimonialCard({
  t
}: {
  t: (typeof TESTIMONIALS)[number];
}) {
  const initials = t.name.split(' ').map(w => w[0]).slice(0, 2).join('');
  return <figure className="flex w-[340px] flex-none flex-col rounded-md bg-white p-7 shadow-md ring-1 ring-sand sm:w-[420px]" data-id="element-24" data-mp="14crajgmk6uwo">
      <QuoteIcon className="h-8 w-8 flex-none text-gold" data-id="element-25" data-mp="19dounyr4pz0t" />
      <blockquote className="mt-4 flex-1 font-serif text-lg leading-relaxed text-neutral-700" data-id="element-26" data-mp="1ddp7xg2hs46a">
        “{t.quote}”
      </blockquote>
      <figcaption className="mt-5 flex items-center gap-3 border-t border-sand pt-4" data-id="element-27" data-mp="3b4s5ao10rdld">
        <span className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-forest font-display text-sm font-semibold text-gold-light" data-id="element-28" data-mp="3f4k78hvwqlhr">
          {initials}
        </span>
        <p className="font-display text-lg text-forest" data-id="element-29" data-mp="32ukq54ri67uu">{t.name}</p>
      </figcaption>
    </figure>;
}
export function DifferentKind() {
  const loop = [...TESTIMONIALS, ...TESTIMONIALS];
  return <section id="different" className="w-full bg-cream py-20 lg:py-28" data-id="element-30" data-mp="2tuxy39knyeeg">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-31" data-mp="3qkou5d8ls9md">
        <div className="mx-auto max-w-2xl text-center" data-id="element-32" data-mp="3qjdthmagfhzh">
          <h2 className="font-display text-3xl leading-tight text-forest sm:text-4xl" data-id="element-33" data-mp="3llu2dlsnraq4">
            A Different Kind of Senior Living Community
          </h2>
          <div className="mx-auto mt-4 h-0.5 w-16 bg-gold" data-id="element-34" data-mp="3hi5uf2046d4c" />
        </div>

        <div className="mt-14 grid gap-px overflow-hidden rounded-md bg-sand ring-1 ring-sand sm:grid-cols-2 lg:grid-cols-4" data-id="element-35" data-mp="3ck4akeuv69rt">
          {STATS.map((stat, i) => <motion.div key={stat.value} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-white px-6 py-10 text-center" data-id="element-36" data-mp="2160hdaw3opnt" data-mpi={i}>
              <p className="font-display text-2xl leading-tight text-forest lg:text-[28px]" data-id="element-37" data-mp="boliv20diph0">
                {stat.value}
              </p>
              <p className="mx-auto mt-3 max-w-[16rem] font-serif leading-relaxed text-neutral-600" data-id="element-38" data-mp="gkiw2zgcbfpk">
                {stat.label}
              </p>
            </motion.div>)}
        </div>
      </div>

      {/* Community dining moment */}
      <div className="mx-auto mt-14 max-w-2xl px-5 lg:px-8" data-id="element-39" data-mp="2nctgtufui5jy">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6
      }} className="overflow-hidden rounded-md shadow-md" data-id="element-40" data-mp="2nffmfoj6eazj">
          <img src="https://cdn.magicpatterns.com/uploads/mXxU2AYJvfczJ6n6ji4Gh5/IMG_4144.png" alt="Brightwood residents sharing a meal together in the community dining room" className="h-56 w-full object-cover object-center" data-id="element-41" data-mp="2tqyzldoz8sqk" />
        </motion.div>
      </div>

      {/* Testimonials */}
      <div className="mx-auto mt-16 max-w-2xl px-5 text-center lg:px-8" data-id="element-42" data-mp="2auqt66k8abto">
        <h2 className="font-display text-3xl leading-tight text-forest sm:text-4xl" data-id="element-43" data-mp="263qyz92hu7uv">
          What Our Residents &amp; Families Say
        </h2>
        <div className="mx-auto mt-4 h-0.5 w-16 bg-gold" data-id="element-44" data-mp="1icv8qgdorkpq" />
      </div>

      {/* Horizontally scrolling testimonials */}
      <div className="marquee-wrap relative mt-12 overflow-hidden" data-id="element-45" data-mp="1dethv9a0qh3p">
        <div className="animate-marquee flex w-max gap-6 px-6" data-id="element-46" data-mp="3dg9ugmjvx6h6">
          {loop.map((t, i) => <TestimonialCard key={i} t={t} data-id="element-47" data-mp="3ife2h9v2oy5x" data-mpi={i} />)}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-cream to-transparent" data-id="element-48" data-mp="3n7e8nk1qknay" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-cream to-transparent" data-id="element-49" data-mp="3r8ziewiz4lgx" />
      </div>
    </section>;
}